import {VNode} from 'snabbdom';
import {Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {apiClient} from 'common/util/api-client';
import {WarningEl} from 'common/components/warning';
import {ApiResponseError} from 'common/util/shared-client';
import {safeSetCookie} from 'common/util/cookie';

import {WarningHeroTheme} from '../warning-hero/constants';

interface JsxProps {
  attrs?: EmptyObj;
}

export class EmbedErrorWrapper extends Component<{validationStatus: number | null}, JsxProps['attrs']> {
  get config() {
    return {
      template: (): VNode => {
        if (this.state.validationStatus === 401) {
          location.reload();
        } else if (this.state.validationStatus === 422) {
          const browserRoot = document.body.querySelector(`mp-browser-context-root`);
          document.body.removeChild(browserRoot);
          return (
            <WarningEl
              attrs={{
                theme: WarningHeroTheme.Error,
                'header-text': `Embed failed to connect.`,
                'body-text': `Please allow cookies to enable embeds. Visit our [Help Center](https://help.mixpanel.com/hc/en-us/articles/12538250505236-Collaborate-in-Figma-with-Mixpanel) for more information.`,
                'cta-text': `Contact Support`,
                'cta-href': `https://help.mixpanel.com/hc/en-us/requests/new`,
              }}
            />
          );
        }
        return null;
      },
      defaultState: {
        validationStatus: null,
      },
    };
  }

  async validateEmbed() {
    await safeSetCookie(`validate_embed`, `1`, 1);
    await apiClient
      .get<EmptyObj>(`/api/app/embed/auth-validate`)
      .catch((error: ApiResponseError) => this.update({validationStatus: error.statusCode}));
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.validateEmbed();
  }
}

export const EmbedWrapperEl = defineAndMakeJsxFactory<JsxProps>(`mp-embed-error-wrapper`, EmbedErrorWrapper);
export const EmbedWrapperReact = panel2react<JsxProps>(`mp-embed-error-wrapper`, EmbedErrorWrapper);
